export { default as FncoPriceSupplySlot } from './FncoPriceSupplySlot';
